import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { MatDialogRef } from '@angular/material/dialog';

export abstract class DraggableDialogBase<T> {
  contentVisible = true;
  dragPosition = { x: 0, y: 0 };

  protected constructor(
    private readonly draggableDialogRef: MatDialogRef<T>,
    private readonly draggablePanelClass: string
  ) {}

  toggleSize(): void {
    if (!this.contentVisible) {
      this.maximizeDialog();
    } else {
      this.minimizeDialog();
    }
  }

  onDragEnded(event: CdkDragEnd): void {
    if (this.contentVisible) {
      this.dragPosition = event.source.getFreeDragPosition();
    }
  }

  minimizeDialog(): void {
    this.contentVisible = false;
    this.dragPosition = { x: 0, y: 0 };
    this.resetDialogTransform();
    this.draggableDialogRef.updatePosition({ bottom: '0', right: '0' });
  }

  maximizeDialog(): void {
    this.contentVisible = true;
    this.dragPosition = { x: 0, y: 0 };
    this.resetDialogTransform();
    this.draggableDialogRef.updatePosition();
  }

  private resetDialogTransform(): void {
    const dialogEl = document.querySelector(`.cdk-overlay-pane.${this.draggablePanelClass}`);
    if (dialogEl) {
      (dialogEl as HTMLElement).style.transform = '';
    }
  }
}
